import React from 'react';

const STEPS = ['Dados Pessoais', 'Tipo de Veículo', 'Detalhes', 'Finalizar'];

export const QuestionarioCarrosProgress = ({ step }) => {
  return (
    <div className="mb-8" data-testid="questionario-carros-progress-wrapper">
      <div className="flex justify-between mb-2" data-testid="questionario-carros-progress-labels">
        {STEPS.map((label, idx) => (
          <span
            key={label}
            className={`text-sm font-medium ${step > idx ? 'text-orange-600' : 'text-gray-400'}`}
            data-testid={`questionario-carros-progress-label-${idx + 1}`}
          >
            {label}
          </span>
        ))}
      </div>
      <div className="h-2 bg-gray-200 rounded-full overflow-hidden" data-testid="questionario-carros-progress-bar-bg">
        <div
          className="h-full bg-orange-600 transition-all duration-300"
          style={{ width: `${(step / 4) * 100}%` }}
          data-testid="questionario-carros-progress-bar-fill"
        />
      </div>
    </div>
  );
};
